import { Box, Card, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink, Outlet } from 'react-router';
import { AuroraBackground } from '@/components/AuroraBackground';
import { ColorModeToggle } from '@/components/ColorModeToggle';
import { PageTransition } from '@/components/PageTransition';
import { useTenant } from '@/tenant/useTenant';

/** Public screens (sign-in) in the tenant's identity. */
export function AuthLayout() {
  const { displayName, config } = useTenant();
  const branding = config.branding;
  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <AuroraBackground />
      <Stack direction="row" sx={{ justifyContent: 'flex-end', p: 1.5 }}>
        <ColorModeToggle />
      </Stack>
      <Box
        component="main"
        sx={{ flex: 1, display: 'grid', placeItems: 'center', px: 2, pb: { xs: 3, sm: 6 } }}
      >
        <PageTransition>
          <Card
            sx={(theme) => ({
              width: '100%',
              maxWidth: 440,
              p: { xs: 3, sm: 4 },
              borderRadius: `${Math.min(Number(theme.shape.borderRadius) * 2.4, 32)}px`,
              boxShadow: `0 24px 64px -24px ${theme.alpha(theme.vars.palette.primary.dark, 0.25)}`,
              ...theme.applyStyles('dark', {
                boxShadow: `0 24px 64px -24px ${theme.alpha('#000', 0.6)}`,
              }),
            })}
          >
            <Outlet />
          </Card>
        </PageTransition>
      </Box>
      <Stack spacing={0.5} sx={{ textAlign: 'center', pb: 2, px: 2 }}>
        {branding?.supportEmail && (
          <Typography variant="caption" color="text.secondary">
            Precisa de ajuda?{' '}
            <Link href={`mailto:${branding.supportEmail}`}>{branding.supportEmail}</Link>
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} {displayName} ·{' '}
          <Link component={RouterLink} to="/privacidade" color="inherit">
            Privacidade
          </Link>{' '}
          ·{' '}
          <Link component={RouterLink} to="/termos" color="inherit">
            Termos
          </Link>
        </Typography>
      </Stack>
    </Box>
  );
}
